import { useRouteError } from 'react-router'
import { PageLayout } from '@/components/layouts/PageLayout.tsx'
import React from 'react'
import { AppLayout } from '@/components/layouts/AppLayout.tsx'
import { isNoPermissionError } from '@/errors/NoPermissionError.ts'
import { PageTitle } from '@/components/PageTitle.tsx'
import { Typography } from 'antd'

const getTitleAndMessage = (error: Error) => {
  const message = error.message as string | undefined
  if (isNoPermissionError(error)) {
    return {
      title: 'Access Denied.',
      message: message,
    }
  }
  if (message?.startsWith('Failed to fetch dynamically imported module')) {
    return {
      title: 'Page Load Error.',
      message: 'There was an issue loading a required module. Please try refreshing the page or contact support if the problem persists.',
    }
  }
  return {
    title: 'Sorry, an unexpected error has occurred.',
    message: message,
  }
}
const ErrorMain = () => {
  const error = useRouteError() as Error
  const { title, message } = getTitleAndMessage(error)

  return (
    <PageLayout className="h-full flex flex-col items-center justify-center">
      <Typography.Title level={1} className="text-3xl font-bold mb-4">{title}</Typography.Title>
      <Typography.Text className="text-xl">{message}</Typography.Text>
    </PageLayout>
  )
}

export const ErrorPage: React.FC = () => {
  return (
    <AppLayout>
      <PageTitle value="Error" />
      <ErrorMain />
    </AppLayout>
  )
}
